import { useQuery } from "@tanstack/react-query";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { api } from "./api";
import Login from "./pages/Login";
import Decks from "./pages/Decks";
import Deck from "./pages/Deck";
import DeckOptions from "./pages/DeckOptions";
import Study from "./pages/Study";
import NoteEditor from "./pages/NoteEditor";
import Profile from "./pages/Profile";
import Logs from "./pages/Logs";

function AuthGate({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { data, isLoading } = useQuery({ queryKey: ["me"], queryFn: () => api.me() });
  if (isLoading) return <div className="p-8 text-slate-500 dark:text-slate-400">Loading…</div>;
  if (!data?.authenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <AuthGate>
            <Decks />
          </AuthGate>
        }
      />
      <Route
        path="/profile"
        element={
          <AuthGate>
            <Profile />
          </AuthGate>
        }
      />
      <Route
        path="/logs"
        element={
          <AuthGate>
            <Logs />
          </AuthGate>
        }
      />
      <Route
        path="/decks/:deckId"
        element={
          <AuthGate>
            <Deck />
          </AuthGate>
        }
      />
      <Route
        path="/decks/:deckId/options"
        element={
          <AuthGate>
            <DeckOptions />
          </AuthGate>
        }
      />
      <Route
        path="/decks/:deckId/study"
        element={
          <AuthGate>
            <Study />
          </AuthGate>
        }
      />
      <Route
        path="/decks/:deckId/new"
        element={
          <AuthGate>
            <NoteEditor mode="create" />
          </AuthGate>
        }
      />
      <Route
        path="/decks/:deckId/notes/:noteId"
        element={
          <AuthGate>
            <NoteEditor mode="edit" />
          </AuthGate>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
